document.addEventListener("DOMContentLoaded", (event) => {
    let sizeQuantities = {};
  
    // *** Check if bundle page
    if (window.location.href.indexOf("bundle") > -1) {
      function addSizesTable() {
        const urlParams = window.location.pathname.split('/');
        const bundleId = urlParams[urlParams.length - 1];
        
        // *** Google Sheets integration
        const sheetId = "1kUZ2ooIdpy1qZGlMzWJWESwejhhbFbv1JjDEM7aseE0";
        const apiKey = "AIzaSyAKheOVBy9W0x_f3qrVfd7iiAPhoU1m_oQ";
        const url = `https://sheets.googleapis.com/v4/spreadsheets/${sheetId}/values/Sheet1?key=${apiKey}`;
        
        fetch(url)
          .then(response => response.json())
          .then(data => {
            const sheetData = data.values;
        
            const matchingBundle = sheetData.find(row => row[0] === bundleId);
            // console.log("::: bundleId, matchingBundle: ");
            // console.log({ bundleId, matchingBundle });
        
            if (matchingBundle) {
              const sizes = matchingBundle[1].split(',').map(size => size.trim());
  
              var rawQuantities = matchingBundle[2];
            
              sizeQuantities = rawQuantities.split(/(?<=\]),\s*/).reduce((acc, item) => {
                const [size, quantity] = item.split(':').map(s => s.trim());
                
                if (size && quantity) {
                  const cleanSize = size.replace(/['"]/g, '');
            
                  const cleanedQuantity = quantity.replace(/[\[\]]/g, '');  // Remove '[' and ']'
                  const parsedQuantities = cleanedQuantity.split(',').map(Number);  // Split by comma and convert to numbers
                  
                  acc[cleanSize] = parsedQuantities;
                }
            
                return acc;
              }, {});

              console.log("::: sizes, sizeQuantities, rawQuantities: ");
              console.log({ sizes, sizeQuantities, rawQuantities });
              populateSizesAndQuantities(sizes, sizeQuantities);
              addProductImages(sheetData, matchingBundle);
            } else {
              console.error(`Bundle ID ${bundleId} not found in Google Sheets data.`);
            }
          })
          .catch(error => {
            console.error("Error fetching Google Sheets data:", error);
          });
        
        function populateSizesAndQuantities(sizes, sizeQuantities) {
        // *** Hide first component
        const items = document.querySelectorAll(".Container-module__kitenzo-container-component");
          if (items[0]) items[0].style.display = 'none';
          
          var htmlSizesSection = `<div class="htmlSizesSection">
            <h2 class=""><span>Vælg størrelse</span></h2>
            <div class="htmlSizesSection-sizes"></div>
          </div>`;
    
          var htmlProductImagesSection = `<section class="htmlProductImagesSection-wrapper"><div class="htmlProductImagesSection"></div></section>`;
      
          var firstStepperItem = document.querySelector(".kitenzo-stepper-item");
          if (firstStepperItem) {
            var newDiv = document.createElement("div");
            newDiv.innerHTML = htmlSizesSection;
    
            var newDivImages = document.createElement("div");
            newDivImages.innerHTML = htmlProductImagesSection;
      
            firstStepperItem.parentNode.insertBefore(newDivImages.firstChild, firstStepperItem);
            firstStepperItem.parentNode.insertBefore(newDiv.firstChild, firstStepperItem);
          }
      
          sizes.forEach((size) => {
            var htmlSize = `<span id="${size}">${size}</span>`;
            var htmlSizesSectionParent = document.querySelector(".htmlSizesSection .htmlSizesSection-sizes");
            htmlSizesSectionParent.insertAdjacentHTML("afterbegin", htmlSize);
          });
    
          eventListenerUpdateSizes(sizeQuantities);
        }
      }
    
      // *** Wait/listen for the elements to load on page, run addSizesTable() function
      function waitForElement() {
        var interval = setInterval(function() {
          var firstStepperItem = document.querySelector(".kitenzo-stepper-item");
          if (firstStepperItem) {
            clearInterval(interval);
            addSizesTable();
          }
        }, 1000);
      }
      waitForElement();
      
      function updateQuantities(size) {
        const quantities = sizeQuantities[size];
        const sections = document.querySelectorAll(".kitenzo-stepper-item");

        console.log({quantities});
        
        sections.forEach((section, index) => {
          const productQuantities = section.querySelectorAll('.ProductQuantityInput-module__kitenzo-quantity');
      
          productQuantities.forEach((input) => {
            const currentQuantity = parseInt(input.value, 10);
            const targetQuantity = quantities[index];
            const increaseButton = input.nextElementSibling;
            const decreaseButton = input.previousElementSibling;
      
            if (currentQuantity < targetQuantity) {
              for (let i = currentQuantity; i < targetQuantity; i++) {
                setTimeout(() => {
                  increaseButton.dispatchEvent(new MouseEvent('click', {
                    bubbles: true,
                    cancelable: true,
                    view: window
                  }));
                }, i * 25);
              }
            } else if (currentQuantity > targetQuantity) {
              for (let i = currentQuantity; i > targetQuantity; i--) {
                setTimeout(() => {
                  decreaseButton.dispatchEvent(new MouseEvent('click', {
                    bubbles: true,
                    cancelable: true,
                    view: window
                  }));
                }, (currentQuantity - i) * 25);
              }
            }
          });
        });
      }
  
      // *** MutationObserver to watch for changes in the DOM
      const observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList' || mutation.type === 'attributes') {
            const activeSizeButton = document.querySelector('.size-button-active');
            if (activeSizeButton) {
              const size = activeSizeButton.id;
              updateQuantities(size);
            }
          }
        }
      });
  
      const targetNode = document.querySelector('.kitenzo-stepper-item');
      if (targetNode) {
        observer.observe(targetNode, {
          childList: true,
          subtree: true,
          attributes: true
        });
      }
  
      // *** Event listener to sizes buttons
      function eventListenerUpdateSizes(sizeQuantities) {
        document.querySelectorAll(".htmlSizesSection-sizes span").forEach((sizeButton) => {
          sizeButton.addEventListener("click", () => {
            const size = sizeButton.id;
            const quantity = sizeQuantities[size];
      
            if (quantity) {
              updateQuantities(size, quantity);
            } else {
              console.error(`No quantities found for size: ${size}`);
            }
      
            document.querySelectorAll('.htmlSizesSection-sizes span').forEach((btn) => {
              btn.classList.remove("size-button-active");
            });
      
            sizeButton.classList.add("size-button-active");
          });
        });
      }
  
      // *** Fetch product images
      function addProductImages(sheetData, matchingBundle) {

        if (matchingBundle) {
          // ***
          // TODO: Adjust this, to use images from matchingBundle[4] if matchingBundle[3] (productHandle) is empty
          // ***
          const productHandle = matchingBundle[3];
          const fetchUrl = `https://garnvaerkstedet.dk/products/${productHandle}.js`;
          
          fetch(`${fetchUrl}`)
          .then(response => response.json())
          .then(data => {
            const imageUrls = data.images;
            const productImagesDiv = document.querySelector(".htmlProductImagesSection");
    
            productImagesDiv.innerHTML = '';
            
            const swiperWrapper = document.createElement('div');
            swiperWrapper.classList.add('swiper-wrapper');
            
            imageUrls.forEach(url => {
              const swiperSlide = document.createElement('div');
              swiperSlide.classList.add('swiper-slide');
            
              const img = document.createElement('img');
              img.src = url;
              
              swiperSlide.appendChild(img);
              swiperWrapper.appendChild(swiperSlide);
            });
            
            productImagesDiv.appendChild(swiperWrapper);
            
            const nextButton = document.createElement('div');
            nextButton.classList.add('swiper-button-next');
            
            const prevButton = document.createElement('div');
            prevButton.classList.add('swiper-button-prev');
            
            productImagesDiv.appendChild(nextButton);
            productImagesDiv.appendChild(prevButton);
            
            // Create and append pagination
            const pagination = document.createElement('div');
            pagination.classList.add('swiper-pagination');
            
            productImagesDiv.appendChild(pagination);
            
            new Swiper('.htmlProductImagesSection', {
              slidesPerView: 1,
              spaceBetween: 0,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              pagination: {
                el: '.swiper-pagination',
                clickable: true,
              },
            });
    
          })
          .catch(error => console.error('Error fetching product data:', error));
        }
      }
      
    } // --- End if bundle page
  })